import { render, staticRenderFns } from "./Favourite.vue?vue&type=template&id=d2e5b258&"
import script from "./Favourite.ts?vue&type=script&lang=ts&"
export * from "./Favourite.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports